module.exports = __webpack_public_path__ + "static/media/amusement(26).0aa16e04.PNG";